import generateAnchorsParams from './generateAnchorsParams'

/**
 * Data for generation anchored section
 * @param {Array} sections - a number that defaults to zero when not provided.
 * @return {Object} data - with title and id for current section
 * @return {string} data.title
 * @return {string} data.id
 */

export default function generateAnchors(sections) {
  return sections.map(section => {
    const { type, title, slug } = section
    const [anchorTitle, anchorId] = generateAnchorsParams({ type, title, slug })
    return { title: anchorTitle, id: anchorId }
  })
}
